import React, { useState } from 'react';
import { CalculatorIcon, DollarSignIcon, PieChartIcon, TrendingUpIcon, BuildingIcon } from 'lucide-react';
import { LoanCalculator } from './tools/LoanCalculator';
import { SavingsCalculator } from './tools/SavingsCalculator';
import { BudgetPlanner } from './tools/BudgetPlanner';
import { InvestmentCalculator } from './tools/InvestmentCalculator';
import { PortfolioCashflow } from './tools/PortfolioCashflow';
type TabType = 'loan' | 'savings' | 'budget' | 'investment' | 'portfolio';
export function ToolsSection() {
  const [activeTab, setActiveTab] = useState<TabType>('loan');
  const tabs = [{
    id: 'loan',
    label: 'Loan Calculator',
    icon: CalculatorIcon
  }, {
    id: 'portfolio',
    label: 'Portfolio Cashflow',
    icon: BuildingIcon
  }, {
    id: 'savings',
    label: 'Savings Goal',
    icon: DollarSignIcon
  }, {
    id: 'budget',
    label: 'Budget Planner',
    icon: PieChartIcon
  }, {
    id: 'investment',
    label: 'Investment Growth',
    icon: TrendingUpIcon
  }];
  return <section id="tools" className="py-24 bg-[#0a0a1a] relative z-10" data-id="element-476">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        <div className="text-center mb-16" data-id="element-478">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-479">
            Interactive Financial Tools
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-480">
            Model your financial future with our suite of precision calculators.
            Data-driven insights to help you make informed decisions.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-481">
          {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return <button key={tab.id} onClick={() => setActiveTab(tab.id as TabType)} className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all ${isActive ? 'bg-blue-600 text-white shadow-[0_0_20px_rgba(59,130,246,0.3)]' : 'bg-white/5 text-slate-400 hover:bg-white/10 hover:text-white border border-white/5'}`} data-id="element-482">
                <Icon className="w-5 h-5" data-id="element-483" />
                {tab.label}
              </button>;
        })}
        </div>

        {/* Tool Content Container */}
        <div className="bg-white/[0.02] border border-white/10 rounded-3xl p-4 sm:p-8 backdrop-blur-sm shadow-2xl" data-id="element-484">
          {activeTab === 'loan' && <LoanCalculator data-id="element-485" />}
          {activeTab === 'portfolio' && <PortfolioCashflow data-id="element-486" />}
          {activeTab === 'savings' && <SavingsCalculator data-id="element-487" />}
          {activeTab === 'budget' && <BudgetPlanner data-id="element-488" />}
          {activeTab === 'investment' && <InvestmentCalculator data-id="element-489" />}
        </div>
      </div>
    </section>;
}